import { JsonResult } from './../models/helper.model';
import { LinqPredicateDTO } from './../models/linqPredicate.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { UserListDTO, UserDTO, ChangePasswordDTO } from './../models/user.model';
import { LinqFilterDTO } from '../models/linqPredicate.model';
import { CompanyDTO, CompanyListDTO } from '../models/company.model';
import { FilterService } from './filter.service';
import { OldSystemSurveyDTO } from '../models/survey.model';


@Injectable({ providedIn: 'root' })

/**
 * Sevizio per utenti
 */
export class UserService {

  constructor(private http: HttpClient, private filterService: FilterService) { }


  getUserByID(id: string): Promise<UserDTO> {
    return this.http.get<UserDTO>(environment.apiFullUrl + '/User/' + id).toPromise();
  }

  /**
   * Restituisce tutte le aziende gestibili dall'utente connesso
   * @param includeMyCompany Se settato a true, include l'azienda di appartenenza
   */
  getAllUserCompanies(includeMyCompany: boolean, routeDashboard: boolean = false): Promise<Array<CompanyListDTO>> {
    return this.http.get<Array<CompanyListDTO>>(environment.apiFullUrl + '/User/GetAllCompaniesByUser/' + includeMyCompany + '/' + routeDashboard).toPromise();
  }

  /**
   * Chiude la collaborazione con un'azienda
   * @param companyID ID dell'azienda
   */
  endCompanyCollaboration(companyID): Promise<any> {
    return this.http.post<any>(environment.apiFullUrl + '/User/EndCompanyCollaboration/' + companyID, null).toPromise();
  }

  saveUser(user: UserDTO): Promise<any> {
    return this.http.post<any>(environment.apiFullUrl + '/User', user).toPromise()
  }

  deleteUser(id: string): Promise<any> {
    return this.http.delete<any>(environment.apiFullUrl + '/User/' + id).toPromise();
  }

  setDisableStatus(id: number, disableStatus: boolean): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + '/User/' + id + '/disablestatus/' + disableStatus).toPromise();
  }

  resetPassword(id: number, password?: string, oldPassword?: string, email?: string): Promise<any> {
    let data: any = {
      ID: id,
      Password: password,
      OldPassword: oldPassword,
      Email: email
    }

    return this.http.post<any>(environment.apiFullUrl + '/User/ResetPassword', data).toPromise()
  }
  
  
  ResetMyNamirial(id: string): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + '/User/ResetMyNamirial/' + id).toPromise();    
  }

  getAllUsers(linqPredicate: Array<LinqPredicateDTO> = null): Promise<Array<UserListDTO>> {

    if (linqPredicate == null || linqPredicate == undefined)
      linqPredicate = new Array<LinqPredicateDTO>();

    let fk_companyPredicate: Array<LinqPredicateDTO> = this.filterService.getCompanyHierarchyFilter("FK_Company");

    //Lo accoda agli eventuali filtri che arrivano come parametri
    let linqPredicates: Array<LinqPredicateDTO> = fk_companyPredicate.concat(linqPredicate);

    return this.http.post<Array<UserListDTO>>(environment.apiFullUrl + '/User/GetAll', linqPredicates).toPromise();
  }

  getUsersByCompany(FK_Company: number) {
    return this.http.get<Array<UserListDTO>>(environment.apiFullUrl + '/User/GetUsersByCompany/' + FK_Company).toPromise();
  }

  resetPasswordByEmail(email: string) {
    return this.http.get<any>(environment.apiFullUrl + '/Login/ResetPassword/' + email).toPromise();
  }
    sendResetPasswordByEmail(email: string) {
    return this.http.get<any>(environment.apiFullUrl + '/User/ResetPassword/' + email).toPromise();
  }
  
  changePassword(dto: ChangePasswordDTO) {
    return this.http.post<any>(environment.apiFullUrl + '/User/ChangePassword', dto).toPromise();
  }

  getOldSystemURL(): Promise<any> {
    const httpOptions = {
      responseType: 'text' as 'json',
      headers: new HttpHeaders({
      })
    };

    return this.http.get<any>(environment.apiFullUrl + '/User/GetOldSystemURL', httpOptions).toPromise();
  }

  sendSurveyViaEmail(dto: OldSystemSurveyDTO): Promise<any> {
    return this.http.post<any>(environment.apiFullUrl + '/User/SendSurveyViaEmail', dto).toPromise();
  }

  sendCommercialEmail(fk_company: number): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + '/User/SendCommercialEmail/' + fk_company).toPromise();
  }


  GetInvoiceInfoPackage(fk_company: number): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + '/User/GetInvoiceInfoPackage/' + fk_company).toPromise();
  }

  /**
   * Si occupa di impostare il campo Enabled con il valore passato nel parametro per tutti gli utenti aventi FK_Company uguale al parametro passato
   * @param fk_company ID della company per cui recuperare gli utenti
   * @param enabled Valore da impostare per il campo enabled
   * @returns
   */
  setStatusForAllCompanyUsers(fk_company: number, enabled: boolean): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + '/User/SetStatusForAllCompanyUsers/' + fk_company + '/' + enabled).toPromise();
  }

  updateUserEmails(userID: string, newUserEmail: string): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + '/User/UpdateUserEmails/' + userID + '/' + newUserEmail).toPromise();
  }

  resetToDefaultPassword(id: string) {
    return this.http.get(environment.apiFullUrl + '/User/ResetToDefaultPassword/' + id).toPromise();
  }

  UserAuthorized(fk_company:number) {
    return this.http.get(environment.apiFullUrl + '/User/UserAuthorized/' + fk_company).toPromise();
  }

  setPolicyToReaded(id: string): Promise<JsonResult> {
    return this.http.get<JsonResult>(environment.apiFullUrl + '/User/SetPolicyToReaded/' + id).toPromise();
  }

  setPolicyShopToReaded(id: string): Promise<JsonResult> {
    return this.http.get<JsonResult>(environment.apiFullUrl + '/User/SetPolicyShopToReaded/' + id).toPromise();
  }

  setSurveyDone(id: string): Promise<JsonResult> {
    return this.http.get<JsonResult>(environment.apiFullUrl + '/User/SetSurveyDone/' + id).toPromise();
  }
  
  setThemes(id: string, isDarkMode: boolean ): Promise<JsonResult> {
    return this.http.get<JsonResult>(environment.apiFullUrl + '/User/setThemes/' + id + '/' + isDarkMode).toPromise();
  }
  MyNamirialUserBind(id: string, mynamirialtoken: string): Promise<JsonResult> {      
        
    let bindingData: any = {
      UserId: id,      
      MyNamirialToken: mynamirialtoken      
    };

    return this.http.post<JsonResult>(environment.apiFullUrl + '/User/MyNamirialUserBind' , bindingData).toPromise();
  }

  DashBoardInfo(id: number) {
    return this.http.get<any>(environment.apiFullUrl + '/User/DashBoardInfo/' +  id).toPromise();
  }


}
